import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  background: #1f242b;
  color: #f8fafc;
  padding: 3.25rem 1.25rem 1.5rem;
`;

export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1.4fr repeat(3, 1fr);
  gap: 2rem;
  margin: 0 auto;
  max-width: 1180px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FooterBrand = styled.div`
  span {
    display: block;
    font-size: 1.4rem;
    font-weight: 800;
    letter-spacing: 0;
    margin-bottom: 0.75rem;
  }

  p {
    color: #cbd5e1;
    line-height: 1.7;
    margin: 0;
    max-width: 34rem;
  }
`;

export const FooterLinkList = styled.ul`
  display: grid;
  gap: 0.65rem;
  list-style: none;
  margin: 0;
  padding: 0;

  li,
  a {
    color: #dbe4ee;
    font-size: 0.96rem;
    line-height: 1.5;
    text-decoration: none;
  }

  a:hover,
  a:focus-visible {
    color: #ffffff;
    text-decoration: underline;
    text-underline-offset: 0.2rem;
  }
`;

export const FooterBottom = styled.div`
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: #aebccc;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin: 2.5rem auto 0;
  max-width: 1180px;
  padding-top: 1.25rem;

  @media (max-width: 620px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
